// @flow
import PropTypes from 'prop-types';

import type { Miliseconds, TimesheetProjection } from '../../typings';
import AnimatedRow from '../Forms/AnimatedRow';
import RowIcon from '../Forms/RowIcon';
import RowContent from '../Forms/RowContent';
import Label from '../Text/Label';
import ContentText from '../Text/ContentText';
import getBreakMinutes from '../../../timeClock/utils/getBreakMinutes';
import getClockedInMinutes from '../../../timeClock/utils/getClockedInMinutes';
import { formatTime, getDisplayDuration } from '../../../utils/Utils';
import timeGreenIcon from '../../../assets/svg/icons/time-green.svg';
import timeGrayIcon from '../../../assets/svg/icons/time-gray.svg';
import breakOrangeIcon from '../../../assets/svg/icons/break-orange.svg';

type Props = {
  timesheetProjections: Array<TimesheetProjection>,
  usTimeFormat: boolean,
  initialAnimationDelay: Miliseconds
};

export default function TimesheetEntries({
  timesheetProjections,
  usTimeFormat,
  initialAnimationDelay
}: Props) {
  return (timesheetProjections: any).map((projection: TimesheetProjection, index: number) => {
    const breakMinutes = getBreakMinutes(projection);
    const clockInMinutes = getClockedInMinutes(projection);
    const displayDuration = getDisplayDuration(clockInMinutes);

    return (
      <div key={projection.id}>
        <AnimatedRow borderTop={!index} borderBottom delay={initialAnimationDelay}>
          <RowIcon src={timeGreenIcon} />
          <RowContent>
            <Label>Clocked in</Label>
            <ContentText>
              {formatTime(projection.clockIn, usTimeFormat)}
              {!projection.clockOut && displayDuration ? ` • ${displayDuration}` : ''}
            </ContentText>
          </RowContent>
        </AnimatedRow>
        {Boolean(breakMinutes) && (
          <AnimatedRow borderBottom delay={initialAnimationDelay}>
            <RowIcon src={breakOrangeIcon} />
            <RowContent>
              <Label>Break</Label>
              <ContentText>{getDisplayDuration(breakMinutes)}</ContentText>
            </RowContent>
          </AnimatedRow>
        )}
        {projection.clockOut && (
          <AnimatedRow borderBottom delay={initialAnimationDelay}>
            <RowIcon src={timeGrayIcon} />
            <RowContent>
              <Label>Clocked out</Label>
              <ContentText>
                {formatTime(projection.clockOut, usTimeFormat)}
                {displayDuration ? ` • ${displayDuration}` : ''}
              </ContentText>
            </RowContent>
          </AnimatedRow>
        )}
      </div>
    );
  });
}

TimesheetEntries.propTypes = {
  timesheetProjections: PropTypes.array,
  usTimeFormat: PropTypes.bool,
  initialAnimationDelay: PropTypes.number
};
